import axios from "axios";
import { voiceCloning, speech_api, s3_files_url } from "../apis";

// Reads a source script file's text from S3 (used as the TTS input).
const fetchSourceText = async (fileId, fileName) => {
  let res = await axios.get(`${s3_files_url}/${fileId}/${fileName}`, {
    headers: { "Cache-Control": "no-cache" },
  });
  return res.data;
};

// Reads a source audio file from S3 as a Blob (used to feed the STS endpoint).
const fetchSourceAsBlob = async (fileId, fileName) => {
  let res = await axios.get(`${s3_files_url}/${fileId}/${fileName}`, {
    responseType: "blob",
  });
  return res.data;
};

// TTS: synthesize speech from script text. Backend renders, stores to S3 and
// saves a drafted-file record, then returns { message, draftFile }.
const generateAudioFromText = async (body) => {
  let res = await axios.post(voiceCloning.streamAudio, body);
  return res.data;
};

// STS (voice changer): re-render a source audio file in the target-language
// cloned voice. Multipart: the `audio` field carries the source recording, the
// rest of `body` carries the draft metadata. Returns { message, draftFile }.
const convertSourceAudio = async ({ audioBlob, body }) => {
  let form = new FormData();
  form.append("audio", audioBlob, "source.mp3");
  Object.entries(body).forEach(([key, value]) => {
    if (value !== undefined && value !== null) form.append(key, value);
  });
  let res = await axios.post(speech_api.speechToSpeech, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export {
  fetchSourceText,
  fetchSourceAsBlob,
  generateAudioFromText,
  convertSourceAudio,
};
